import React, {
  useRef,
} from 'react';
import clsx from 'clsx';
import {
  isEmptyString,
  notEmptyString,
} from '@populateui/utils';
import Tag from 'core/components/Tag';
import ToolTip from 'core/components/Tooltip';
import {
  formatDate,
} from 'utils/date';
import {
  WorkflowEncounterSummaryDTO,
} from 'dtos';
import {
  DEFAULT_EMPTY_VALUE,
} from 'core/constants';

type Props = {
  encounter?: WorkflowEncounterSummaryDTO | null;
  className?: string;
};

type ActiveEncounterDisplayProps = {
  encounter: WorkflowEncounterSummaryDTO;
  className?: string;
};

function DeletedEncounterDisplay() {
  return <span className="text-gray-400">Deleted</span>;
}

function EmptyEncounterDisplay() {
  return <span className="text-gray-400">{DEFAULT_EMPTY_VALUE}</span>;
}

function ActiveEncounterDisplay({
  encounter,
  className,
}: ActiveEncounterDisplayProps) {
  const reasonRef = useRef<HTMLSpanElement>(null);
  const { encounterStartDateTime } = encounter;
  const { typeOfVisitDescription } = encounter;
  const { reasonForVisit } = encounter;
  const reason = reasonForVisit ?? '';

  return (
    <div className={clsx('flex min-w-0 items-center gap-3', className)}>
      <div className="flex min-w-0 flex-col gap-1">
        {notEmptyString(typeOfVisitDescription) && (
          <Tag tagName={typeOfVisitDescription ?? ''} className="w-fit max-w-[10rem] truncate" />
        )}
        <ToolTip title={reason} auto ref={reasonRef}>
          <span
            ref={reasonRef}
            className="truncate text-xs text-gray-500"
          >
            {reason}
            {' '}
            •
            {' '}
            {formatDate(encounterStartDateTime ?? '')}
          </span>
        </ToolTip>
      </div>
    </div>
  );
}

export default function WorkflowEncounterDisplay({
  encounter,
  className,
}: Props) {
  let content;

  if (encounter?.isDeleted) {
    content = <DeletedEncounterDisplay />;
  } else if (!encounter || isEmptyString(encounter.encounterStartDateTime ?? '')) {
    content = <EmptyEncounterDisplay />;
  } else {
    content = (
      <ActiveEncounterDisplay
        encounter={encounter}
        className={className}
      />
    );
  }

  return content;
}
